import { render, staticRenderFns } from "./CreateMerchantModal.vue?vue&type=template&id=1996e320&scoped=true&"
import script from "./CreateMerchantModal.vue?vue&type=script&lang=js&"
export * from "./CreateMerchantModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateMerchantModal.vue?vue&type=style&index=0&id=1996e320&scoped=true&lang=css&"
import style1 from "./CreateMerchantModal.vue?vue&type=style&index=1&id=1996e320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1996e320",
  null
  
)

export default component.exports